import { inject, Injectable, Provider } from '@angular/core'

import { UserProfile } from '@ti/contracts'
import { USER_DIRECTORY_EVENTS } from '@ti/core/contracts/user-directory-events'
import { BaseUserManager } from '@ti/shared/user/services'
import { UserDirectoryKind } from '@ti/shared/user/stores'

@Injectable()
export class FleetUserManager extends BaseUserManager {
  protected readonly userDirectory = UserDirectoryKind.Fleet
  protected override readonly updateMessageSummaryKey = ''
  protected override readonly deleteMessageSummaryKey = ''
  protected override readonly resendInviteMessageSummaryKey = ''

  public async sendInviteEmail(user: UserProfile) {
    return this.api.fleet.user.sendInviteEmail(user.id)
  }

  protected async createUser(data: Partial<UserProfile>) {
    // Replace an empty array with NULL
    data.groupsAccess = data.groupsAccess?.length ? data.groupsAccess : null
    return this.api.fleet.user.create(data)
  }

  protected async updateUser(user: UserProfile, data: Partial<UserProfile>) {
    // Replace an empty array with NULL
    data.groupsAccess = data.groupsAccess?.length ? data.groupsAccess : null
    return this.api.fleet.user.update(user.id, data)
  }

  protected async deleteUser(user: UserProfile) {
    return this.api.fleet.user.remove(user.id)
  }

  protected async disableUserMfa(user: UserProfile) {
    return this.api.fleet.user.disableMfa(user.id)
  }
}

export const provideFleetUserManager = (): Provider[] => {
  return [
    FleetUserManager,
    { provide: BaseUserManager, useExisting: FleetUserManager },
    { provide: USER_DIRECTORY_EVENTS, useFactory: () => inject(FleetUserManager).events$ },
  ]
}
